import { render, staticRenderFns } from "./Publish.html?vue&type=template&id=6704daae&scoped=true&"
import script from "./Publish.js?vue&type=script&lang=js&"
export * from "./Publish.js?vue&type=script&lang=js&"
import style0 from "./Publish.scss?vue&type=style&index=0&id=6704daae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6704daae",
  null
  
)

export default component.exports